import React from 'react';
import { LayerGroup, WMSTileLayer, LayersControl } from 'react-leaflet';
import RasterDataLegend from '../legends/RasterDataLegend.jsx';

const { Overlay, } = LayersControl
const GEOSERVER_POPULATION_LAYER_NAME = 'total_population'
const AVAILABLE = true

export class PopulationLayers {

    static getMapLayers(t) {

        const name = t("map.totalPopulation") + (AVAILABLE ? "" : " (Unavailable)");

        return (
            <Overlay name={name}> 
                <LayerGroup id="populationLayer">
                    <WMSTileLayer
                        url='/maps/geodata/wms'
                        layers={GEOSERVER_POPULATION_LAYER_NAME}
                        format='image/png'
                        transparent='true'
                        opacity="0.7"
                    /> 
                </LayerGroup>
            </Overlay>
        )
    }

    static getLegend(t) {
        return <RasterDataLegend
            layerName="populationLayer"
            layerTitle={t("map.totalPopulation")}
            noDataLabel={t("map.noPopulationData")}
            url="/legends/population/"
            unitsLabel=""
        />;
    }
}